import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Recorder from "recorder-js";

function Hero() {
    const [isRecording, setIsRecording] = useState(false);
    const recorderRef = useRef(null);
    const audioContextRef = useRef(null);
    const navigate = useNavigate();
    const [isDragging, setIsDragging] = useState(false);
    const [isLoading, setIsLoading] = useState(false);



    const handleMicStart = async () => {
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        recorderRef.current = new Recorder(audioContextRef.current);
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        recorderRef.current.init(stream);
        recorderRef.current.start();
        setIsRecording(true);
    };

    const handleMicStop = async () => {
        const { blob } = await recorderRef.current.stop();
        const file = new File([blob], "recording.wav", { type: "audio/wav" });
        await uploadFile(file);
        setIsRecording(false);
    };

    const uploadFile = async (file) => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("file", file);

        const res = await fetch("https://api.digitalladyland.com/extract-chords", {
            method: "POST",
            body: formData,
        });

        const data = await res.json();
        setIsLoading(false);

        if (data.chords) {
            const audioURL = URL.createObjectURL(file);  // <-- create local playback URL
            navigate("/results", { state: { chords: data.chords, tempo: data.tempo, key: data.key, audioURL, fileName: file.name } });
        } else {
            alert("Chord extraction failed.");
        }
    };

    const handleFileSelect = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        await uploadFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };
    
    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith("audio/")) {
            uploadFile(file);
        }
    };

    return (
        <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className="relative"
        >
        {isDragging && (
            <div className="absolute inset-0 bg-black bg-opacity-50 text-white flex items-center justify-center text-xl font-bold z-50 pointer-events-none">
            Drop your audio file to extract chords
            </div>
        )}

        {isLoading && (
        <div className="absolute inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center text-white text-xl font-semibold">
            <div className="flex items-center gap-4">
            <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
            Finding chords...
            </div>
        </div>
        )}
        
        <section 
            className="pt-40 flex flex-col items-center justify-center text-center px-6 py-20 md:py-32 lg:py-40 z-10"
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
        >
            <h1 className="text-4xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-teal-400 to-purple-500 mb-5 drop-shadow-lg pt-3 pb-3 md:pt-3 md:pb-3">
                Discover the Chords in Every Song
            </h1>
            <p className="text-base md:text-lg text-white/60 mb-8 max-w-xl">
                Upload a song or record live to instantly reveal its chords. Perfect for musicians, learners, and creators.
            </p>
            <button
                onClick={isRecording ? handleMicStop : handleMicStart}
                className="flex items-center gap-2 bg-white text-black font-semibold px-5 py-2 rounded-full shadow-md hover:bg-gray-200 transition duration-200"
                >
                {isRecording ? (
                    <span className="w-3 h-3 rounded-full bg-red-600 blinking-dot"></span>
                ) : (
                    <img src="/images/mic-icon.svg" alt="mic icon" className="w-5 h-5" />
                )}
                {isRecording ? "Stop Recording" : "Record"}
            </button>

            <p className="text-sm text-gray-400 mt-4">
                – or –
                <br />
                Drag and drop audio file here, or{" "}
                <span
                    className="underline cursor-pointer text-white hover:text-purple-300"
                    onClick={() => document.getElementById("fileInput").click()}
                >
                    select a file
                </span>
            </p>

            <input
                id="fileInput"
                type="file"
                accept="audio/*"
                className="hidden"
                onChange={handleFileSelect}
            />
        </section>

        </div>
    );
}

export default Hero;
